<div class="patient">
  <div class="wrapper">
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel dsp-flex">
        <h1 class="t-title-main">Reports</h1>

        <div style="display: flex; justify-content: center; align-items: center; gap: 1em">
          <button class="clear-btn" style="width: fit-content" (click)="goToBilling()">Back</button>
          <img
            style="cursor: pointer; margin: 0 5% 0 0"
            height="41em"
            width="41em"
            *ngIf="searchResults?.length > 0"
            src="../../assets/icons/print.svg"
            (click)="printBillingReport()"
          />
          <img
            style="cursor: pointer"
            [matTooltip]="'billing.gui.tooltips.Settings' | translate"
            height="41em"
            width="41em"
            src="../../assets/icons/gear-white.svg"
            (click)="goToSettings()"
          />
        </div>
      </div>
    </header>

    <main class="l-deashboard">
      <div class="m-box">
        <h2>Document search</h2>
        <div style="display: flex; gap: 2em">
          
          <div *ngIf="loginService.clinicUsers" class="inputs-container">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "billing.gui.labels.Doctor" | translate }}
              </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1">
                <select [(ngModel)]="doctorUID" class="t-select-black w100">
                  <option *ngFor="let doctor of getDoctors()" [ngValue]="doctor.UID">
                    {{ doctor.Title + " " + doctor.Name }}
                  </option>
                </select>
              </span>
            </div>
          </div>

          <div *ngIf="loginService.userBilling" class="inputs-container">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "billing.gui.labels.Doctor" | translate }}
              </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1">
                <select [(ngModel)]="doctorUID" class="t-select-black w100">
                  <option *ngFor="let doctor of getDoctor()" [ngValue]="doctor.UID">
                    {{ doctor.Title + " " + doctor.Name }}
                  </option>
                </select>
              </span>
            </div>
          </div>

          <div class="inputs-container">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> Type </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1">
                <select [(ngModel)]="documentType" class="t-select-black w100">
                  <option *ngFor="let document of documentTypes" [value]="document.value">
                    {{ document.label }}
                  </option>
                </select>
              </span>
            </div>
          </div>
          <div class="inputs-container">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> From </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1" style="display: flex">
                <input matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate" class="t-field-text w100" />
                <mat-datepicker #fromPicker></mat-datepicker>
                <img src="../../assets/icons/date.svg" (click)="fromPicker.open()" style="margin-left: -1.8em" />
              </span>
            </div>
          </div>
          <div class="inputs-container">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> To </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1" style="display: flex">
                <input matInput [matDatepicker]="toPicker" [(ngModel)]="toDate" class="t-field-text w100" />
                <mat-datepicker #toPicker></mat-datepicker>
                <img src="../../assets/icons/date.svg" (click)="toPicker.open()" style="margin-left: -1.8em" />
              </span>
            </div>
          </div>
         

          
          <button
            class="blue-btn"
            (click)="search()"
            [disabled]="isLoading || !doctorUID || !documentType || !toPicker || !toPicker"
          >
            Search
          </button>
        </div>
        <hr class="divider" />
        <h3 *ngIf="searchResults?.length > 0" style="margin-bottom: 1em">Results</h3>

        <ng-container *ngIf="searchResults?.length === 0">
          <div style="text-align: center">
            <h5>No Invoices Were Found</h5>
          </div>
        </ng-container>

        <ng-container *ngIf="searchResults?.length > 0">
          <div class="container">
            <table style="width: 100%">
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    {{ "billing.gui.labels.DocumentType" | translate }}
                  </th>
                  <th (click)="sortData('DateCreated')" class="clickable">
                    {{ "billing.gui.labels.Creation Date" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.Number" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.CustomerName" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.ServiceDescription" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.Payment Method" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.Amount" | translate }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngIf="isLoading" class="loading-row">
                  <td *ngFor="let col of columns">
                    <div class="loading-effect"></div>
                  </td>
                </tr>
                <ng-container *ngIf="!isLoading">
                  <tr *ngFor="let result of searchResults; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ result.TypeName }}</td>
                    <td>{{ result.DateCreated | date : "dd.MM.yyyy" : "UTC" }}</td>
                    <td style="cursor: pointer;" (click)="openPdf(result.CopyLink)" matTooltip="Click to view document">{{ result.DocumentNumber }}</td>
                    <td>{{ result.Recipient }}</td>
                    <td>{{ result.Subject }}</td>
                    <td>{{ result.PaymentMethodName }}</td>
                    <!-- <td>{{ result.Price }} ₪</td> -->
                    <td>{{ adjustPrice(result) }} ₪</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </ng-container>
        <div *ngIf="searchResults?.length" style="display: flex; justify-content: end; margin-top: 1em">
          <!-- <h3>Total: {{ searchResults?.length }}</h3> -->
          <h3 *ngIf="searchResults?.length > 1">Total Amount: {{ getTotalAmount() }} ₪</h3>
        </div>
      </div>

      <div class="m-box">
        <h2>Check search</h2>
        <div style="display: flex; gap: 2em">
          
          <div *ngIf="loginService.clinicUsers" class="inputs-container">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "billing.gui.labels.Doctor" | translate }}
              </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1">
                <select [(ngModel)]="doctorUIDc" class="t-select-black w100">
                  <option value="0">All</option>
                  <option *ngFor="let doctor of getDoctors()" [ngValue]="doctor.UID">
                    {{ doctor.Title + " " + doctor.Name }}
                  </option>
                </select>
              </span>
            </div>
          </div>

          <div *ngIf="loginService.userBilling" class="inputs-container">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "billing.gui.labels.Doctor" | translate }}
              </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1">
                <select [(ngModel)]="doctorUIDc" class="t-select-black w100">
                  <option value="0">{{'billing.gui.labels.All' | translate}}</option>
                  <option *ngFor="let doctor of getDoctor()" [ngValue]="doctor.UID">
                    {{ doctor.Title + " " + doctor.Name }}
                  </option>
                </select>
              </span>
            </div>
          </div>

          <div class="inputs-container" style="padding-top: 0.5em;">
            <div class="t-field l-flex t-twin-fieldset">
              <label>
                <input
                  type="checkbox"
                  name="paid"
                  [(ngModel)]="paid"
                  class="custom-check customInput"
                  aria-labelledby="pregnancy_popup-sex"
                  (click)="invoicesSelection()"
                />

                <i class="customInput-display"></i>
                <span class="t-field-desc">
                  {{'billing.gui.labels.Ready for Invoice' | translate}}
                </span>
              </label>
             
            </div>
          </div>

          <div class="inputs-container">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> {{'billing.gui.labels.From' | translate}} </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1" style="display: flex">
                <input matInput [matDatepicker]="fromPickerC" [(ngModel)]="fromDateC" [max]="today" class="t-field-text w100" />
                <mat-datepicker #fromPickerC></mat-datepicker>
                <img src="../../assets/icons/date.svg" (click)="fromPickerC.open()" style="margin-left: -1.8em" />
              </span>
            </div>
          </div>

          <div class="inputs-container" *ngIf="! paid">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> {{'billing.gui.labels.Until' | translate}} </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1" style="display: flex">
                <input matInput [matDatepicker]="toPickerC" [(ngModel)]="toDateC" [min]="today" class="t-field-text w100" />
                <mat-datepicker #toPickerC></mat-datepicker>
                <img src="../../assets/icons/date.svg" (click)="toPickerC.open()" style="margin-left: -1.8em" />
              </span>
            </div>
          </div>

          <div class="inputs-container" *ngIf="! paid">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{'billing.gui.labels.Has Invoice' | translate}}
              </label>
              <i class="t-sep"></i>
              <span class="t-validation-wrap l-fg1">
                <select [(ngModel)]="invoices" class="t-select-black w100" [disabled]="paid">
                  <option value="2">{{'billing.gui.labels.All' | translate}}</option>
                  <option value="0">{{'billing.gui.labels.no' | translate}}</option>
                  <option value="1">{{'billing.gui.labels.yes' | translate}}</option>
                </select>
              </span>
            </div>
          </div>
          
          

          

        <button
            class="blue-btn"
            (click)="searchChecks()"
            [disabled]="isLoading || !doctorUIDc ||  !fromDateC"
          >
            Search
          </button>
        

        </div>

        <ng-container *ngIf="checksData?.length > 0">
          <div class="container">
              <table style="width: 100%;">
                  <thead>
                      <tr>
                          <th>
                          {{'billing.gui.labels.Check maturity date' | translate}}
                          </th>
                          <th (click)="sortData('DateCreated')">
                            {{'billing.gui.labels.Receipt' | translate}}
                          </th>
                          <th>
                            {{'billing.gui.labels.Invoice' | translate}}
                          </th>
                          <th>
                              {{'billing.gui.labels.CustomerName' | translate}}
                          </th>
                          <th>
                              {{'billing.gui.labels.ServiceDescription' | translate}}
                          </th>
                          <th>
                              {{'billing.gui.labels.Amount' | translate}}
                          </th>
                          <th>
                              {{'billing.gui.labels.Doctor' | translate}}
                          </th>
                          <!-- <th>Status</th> -->
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngIf="isLoading" class="loading-row">
                          <td *ngFor="let col of columns">
                              <div class="loading-effect"></div>
                          </td>
                      </tr>
                      <tr *ngFor="let check of checksData ; let i = index; ">
                          <td [matTooltip]="'check #:' + check.Number + ', bank:' + check.bank + ', branch:'+ check.branch + ', account #:' + check.Account">{{check.checkDate | date:"dd.MM.yyyy"}}</td>
                          <td (click)="openPdf(check.CopyLink)" matTooltip="Click to view reciept" style="cursor: pointer;">{{check.DateCreated | date:"dd.MM.yyyy"}} #{{check.DocumentNumber}}</td>
                          <td [ngClass]="loadingCheck == check.AutoIndex ? 'loading': '' ">
                            <span *ngIf="check.invoiced" 
                            (click)="openPdf(check.invoiceLink)" 
                            matTooltip="Click to view invoice" 
                            style="cursor: pointer;" 
                            [ngClass]="check['isNew'] ? 'new-item': ''">
                            {{check.invoiced | date:"dd.MM.yyyy"}} #{{check.invoiceNumber}}</span>
                            <button *ngIf="! check.invoiced  && loadingCheck != check.AutoIndex" (click)="invoiceForCheck(check.recieptID, check.AutoIndex)" class="orange-btn" style="margin:0">Generate Invoice</button>
                          </td>
                          <td>{{check.Recipient}} : {{check.PatientID}}</td>
                          <td>{{check.Subject}}</td>
                          <td>{{check.amount}} ₪</td>
                          <td>{{check.DoctorName}}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </ng-container>
      </div>
    </main>
    <aside class="l-sidebar l-flex l-column" style="height: 100%">
      <img class="off-mobile sidebar-logo logo-3d-effect" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
      <!-- <div class="userPanel">
        <i class="userPanel-icon icon-female"> </i>
        <div class="userPanel-userName">
          {{ "billing.gui.labels.Patient Search" | translate }}
        </div>
      </div> -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <app-docpanel></app-docpanel>
    </aside>
    <app-bottombar></app-bottombar>
  </div>
</div>

<app-commerror></app-commerror>
